import { useState } from "react";
import { getFileIcon } from "../utils/Icon";
import { FaTimes, FaRegCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MdOutlineCancelPresentation } from "react-icons/md";

const ShareView = ({ setIsOpen, file }) => {
  const [email, setEmail] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [sharedWith, setSharedWith] = useState([
    { name: "Modheash", email: "mod@gmail.com", role: "Owner" },
  ]);

  const navigate = useNavigate();

  const handleItemClick = (item) => {
    if (item.type === "folder") {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  return (
<div className="fixed inset-0 top-0 z-50 flex justify-end items-start">
  <div className="bg-four rounded-l-lg w-[220px] h-full max-h-screen flex flex-col">
    
    {/* Scrollable Content */}
    <div className="flex-1 overflow-y-auto p-5 space-y-4">
      
      {/* Header */}
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-bold text-gray-800">Share</h2>
        <button onClick={() => setIsOpen(false)}>
          <FaTimes className="text-gray-500 hover:text-black text-sm" />
        </button>
      </div>

      {/* File Preview */}
      <div className="flex items-center gap-2">
        <img
          className={`w-10 h-10 rounded-md object-contain transition-all duration-300 ${
            file?.isLocked && !file?.isDirectory
              ? "blur-sm opacity-50 cursor-not-allowed"
              : ""
          }`}
          onClick={() => handleItemClick(file)}
          src={getFileIcon(file?.name, file?.url)}
          alt={file?.name}
        />
        <span className="font-medium text-sm text-gray-700 truncate">
          {file?.name || "Unnamed File"}
        </span>
      </div>

      {/* Add Email Input */}
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-600">
          People with access
        </label>
        <input
          type="email"
          placeholder="Add e-mail or username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="px-4 py-2 border w-full rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-gray-400"
        />
      </div>

      {/* Shared List */}
      <div className="space-y-3">
        {sharedWith.map((user, index) => (
          <div key={index} className="text-sm text-gray-700">
            <div className="flex items-center gap-2 mb-1">
              <img
                className="w-6 h-6 rounded-full"
                src="/assets/Ellipse 5.png"
                alt={user.name}
              />
              <p className="font-semibold">{user.name}</p>
            </div>
            <p className="text-xs text-gray-500">{user.email}</p>
            <div className="mt-2 inline-block bg-white border px-3 py-1 rounded text-xs font-medium">
              {user.role}
            </div>
          </div>
        ))}
      </div>

      {/* Example Extra User */}
      <div className="flex items-center gap-3 rounded-md hover:bg-gray-100">
        <img
          className="w-6 h-6 rounded-full"
          src="/assets/Ellipse 5.png"
          alt="Rakesh"
        />
        <div className="flex flex-col">
          <p className="font-semibold text-sm text-gray-800">Rakesh</p>
          <span className="text-xs font-medium text-gray-500">
            r@gmail.com
          </span>
        </div>
        <div className="ml-auto">
          <button className="text-gray-400 hover:text-red-500">
            <MdOutlineCancelPresentation className="text-lg" />
          </button>
        </div>
      </div>

      {/* Permissions */}
      <div>
        <div className="flex gap-2 flex-wrap">
          {["View", "Edit", "Comment"].map((perm) => (
            <button
              key={perm}
              className="rounded-md border px-2 py-1 text-xs hover:bg-third"
            >
              {perm}
            </button>
          ))}
        </div>
      </div>

      {/* Anyone Can */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 mt-5">
          Anyone can
        </h4>
        <div className="flex gap-2 flex-wrap mt-2">
          {["View", "Edit", "Comment"].map((perm) => (
            <button
              key={perm}
              className="rounded-md border px-2 py-1 text-xs hover:bg-third"
            >
              {perm}
            </button>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center px-5 py-4">
        <button className="flex items-center gap-2 text-sm text-gray-600 hover:text-black">
          <FaRegCopy className="text-sm" /> Copy
        </button>
        <button
          onClick={() => setIsOpen(false)}
          className="bg-orange-500 text-white px-4 py-2 rounded-md text-sm hover:bg-orange-600"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</div>



  );
};

export default ShareView;
